export {};
//# sourceMappingURL=isdk-info.js.map